<template>
<ul class="social-links flex mb-4 mr-0 vt:mr-6 vt:mb-0">
    <li v-for="(url, site) in links" :class="site">
        <a :href="url" class="relative inline-block" target="_blank" :class="color">
            <i :class="`fa-${site}`" class="transition-colors fa-brands fa-fw" aria-hidden="true"></i>
            <span class="sr-only">Follow on {{ site }}</span>
        </a>
    </li>
</ul>
</template>

<script>
export default {
    props: {
        links: {
            default: {}
        },
        color: {
            default: 'text-white'
        }
    }
}
</script>